<template>
    <div class="c-bottomBar" v-bind:class="isHidden()">
        <div class="c-bottomBar__content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        hidden:{
            default(){
                return false
            },
            type: Boolean
        }
    },
    methods:{
        isHidden(){
            return this.hidden?'':'c-bottomBar--hidden'
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-bottomBar{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: $darkLazuri;
        z-index: 999;
        transition:all .5s;
        height: 3rem;
        &--hidden{
            height: 1px;
        }
        &__content{
            max-width: 1430px;
            widows: 100%;
            margin: 0 auto;
            padding: 1rem;
            color: #fff;
            overflow-y: auto;
            text-align: center;
            @media (max-width:1430px) {
                max-width: 1124px;
            }
        }
    }
</style>